<template>
  <div id="modalTaxa" class="modal-zonas" v-show="opened">
    <div class="modal-zonas-content modal-rounded-scroll">
      <div class="py-4 py-md-3 bg-white shadow-sm">
        <div class="container text-center position-relative">
          <a href="javascript:" @click="closeModal" class="btn btn-outline-light btn-voltar-round position-absolute" style="left: 12px; top: -9px" aria-label="Voltar">
            <i class="fa fa-chevron-left text-dark"></i>
          </a>
          <h1 class="h6 font-weight-bold m-auto">Taxa e Tempo</h1>
        </div>
      </div>
      <div class="container-fluid">
        <div class="text-center border-bottom py-3 mt-3 mb-2" v-if="empresa.entrega_gratis === '1' && empresa.tipo_delivery !== '2'">
          <div class="d-flex align-items-center justify-content-center">
            <icon name="promocao" size="18" class="text-success mr-2"/>
            <span>
              <span class="text-success">Entrega grátis</span><span v-if="empresa.eg_pedido_minimo > 0"> a partir de <b>{{ empresa.eg_pedido_minimo | valor | semCentavosZerados }}</b></span>
            </span>
          </div>
          <div class="small text-muted mt-1" v-if="empresa.geo_disabled === '0'">Para entregas em até <b>{{ empresa.eg_raio / 1000 }} km</b></div>
        </div>
        <div class="my-3" v-if="empresa.geo_disabled === '2'">
          <div v-if="empresa.tipo_delivery !== '2' && zonas.length > 2">
            <input type="search" class="form-control mb-2" v-model="term" @keyup="pesquisarZonas" placeholder="Pesquisar" @keyup.down="$helpers.focusrElement('zona0')">
          </div>
          <a href="javascript:" @click="selecionar(3)" class="card card-zona text-dark" v-if="empresa.tipo_delivery !== '3'">
            <div class="zona-item">
              <icon name="retirada" class="text-primary mr-2" size="18"></icon>
              <div>
                <b>Retirar no local</b>
                <div class="small">
                  <b class="text-success">Grátis</b>
                  <span v-if="!agendamento"> / {{ empresa.media_retirada | tempo }}</span>
                </div>
              </div>
              <i class="fa fa-angle-right text-primary ml-auto"></i>
            </div>
          </a>
          <div class="mb-4" v-if="empresa.tipo_delivery !== '2'">
            <a href="javascript:" @click="selecionar(2, z)" class="card card-zona text-dark" v-for="z in search">
              <div class="zona-item">
                <icon name="address" class="text-primary mr-2" size="18"></icon>
                <div>
                  <b>{{z.nome_zona}}</b>
                  <div class="small">
                    <span v-if="z.taxa_entrega > 0">{{z.taxa_entrega | valor}}</span>
                    <span class="text-success font-weight-bold" v-else>Entrega Grátis</span>
                    <span v-if="!agendamento && z.tempo_entrega > 0"> / {{z.tempo_entrega | tempo}}</span>
                  </div>
                </div>
                <i class="fa fa-angle-right text-primary ml-auto"></i>
              </div>
            </a>
          </div>
        </div>
        <div class="mt-1 mb-3" v-else>
          <div class="raio-item" v-if="empresa.tipo_delivery !== '3'">
            <icon name="retirada" class="text-primary mr-2" size="18"></icon>
            <div>
              <h6 class="font-weight-bold mb-0">Retirar no local</h6>
              <div class="small">
                <b class="text-success">Grátis</b>
                <span v-if="!agendamento && empresa.media_retirada > 0"> / {{empresa.media_retirada | tempo}}</span>
              </div>
            </div>
          </div>
          <div v-if="empresa.tipo_delivery !== '2'">
            <div class="raio-item" v-for="r in empresa.raio_entregas">
              <icon name="delivery" class="text-primary mr-2" size="18"></icon>
              <div>
                <h6 class="font-weight-bold mb-0" v-if="empresa.geo_disabled === '1'">Entregar</h6>
                <h6 class="font-weight-bold mb-0" v-else>Até {{r.raio_entrega / 1000}}Km</h6>
                <div class="small">
                  <span v-if="r.taxa_entrega > 0">{{r.taxa_entrega | valor}}</span>
                  <span class="text-success font-weight-bold" v-else>Entrega Grátis</span>
                  <span v-if="!agendamento"> / {{r.tempo_entrega | tempo}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CardInfo from './CardInfo'
  import Loading from "./Loading";
  import Icon from "./Icon";
  import ModalMenu from "./ModalMenu";

  export default {
    name: "ModalTempo",
    components: {ModalMenu, Icon, Loading, CardInfo},
    props: ['agendamento'],
    filters: {
      semCentavosZerados(valor) {
        return valor.replace(/,00$/, '');
      }
    },
    data() {
      return {
        token: localStorage.getItem('token'),
        opened: false,
        avancar: false,
        term: '',
        search: [],
        dados: {}
      }
    },

    methods: {
      closeModal() {
        this.$emit('close');
        document.body.classList.remove("modal-open");
        this.opened = false;
      },

      abrirModal(avancar) {
        document.body.classList.add("modal-open");
        this.avancar = !!avancar;
        this.search = this.zonas;
        this.term = '';
        this.opened = true;
      },

      selecionar(tipo, r) {
        let taxa = null;

        switch (tipo) {
          case 0:
            taxa = { nome: `Até ${r.raio_entrega / 1000}}Km`, valor: r.taxa_entrega, tempo: r.tempo_entrega }
            break;

          case 1:
            taxa = { nome: `Entregar`, valor: r.taxa_entrega, tempo: r.tempo_entrega }
            break;

          case 2:
            taxa = { nome: r.nome_zona, valor: r.taxa_entrega, tempo: r.tempo_entrega }
            break;

          case 3:
            taxa = { nome: "Retirar no local", valor: 0, tempo: this.empresa.media_retirada }
            break;
        }

        this.$store.state.taxa = taxa;
        this.closeModal();
      },

      pesquisarZonas() {
        if (this.term.trim().length) {
          this.search = this.zonas.filter(z => z.texto.includes(this.term.toLowerCase()) || z.nome_zona.toLowerCase().includes(this.term.toLowerCase()));

        } else {
          this.search = this.zonas;
        }
      },
    },

    computed: {
      zonas() {
        return [...(this.$store.state.empresa.zonas || [])].sort((a, b) => {
          const ordemA = parseInt(a.ordem, 10);
          const ordemB = parseInt(b.ordem, 10);
          const posicaoA = ordemA > 0 ? ordemA : Number.MAX_SAFE_INTEGER;
          const posicaoB = ordemB > 0 ? ordemB : Number.MAX_SAFE_INTEGER;

          return posicaoA - posicaoB || parseInt(a.id_zona, 10) - parseInt(b.id_zona, 10);
        })
      },

      empresa() {
        return this.$store.state.empresa
      }
    },
  }
</script>

<style scoped>
  .modal-zonas {
    display: block;
    position: fixed; /* Stay in place */
    z-index: 1040; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  }

  .modal-zonas-content {
    background-color: #fefefe;
    overflow: auto;
    margin: 48px auto;
    width: 500px;
    height: 75vh;
    position: relative;
    border-radius: 12px;
  }

  .card-zona {
    padding: 14px 16px;
    margin-bottom: 8px;
  }

  .zona-item {
    display: flex;
    align-items: center;
  }

  .card-zona:last-child {
    margin-bottom: 0;
  }

  .raio-item {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e9e9e9;
    padding: 14px 7px;
  }

  @media (max-width: 600px) {
    .modal-zonas-content {
      overflow: auto;
      min-height: 100%;
      height: 100vh;
      width: 100%;
      margin: 0;
      border-radius: 0;
      clip-path: none;
    }
  }
</style>
